export const ERROR_MESSAGES = {
    BAD_REQUEST: "Oops! It seems there was an error with your request. Please check the data you entered and try again.",
    UNAUTHORIZED: "Access denied: Your account is not authorized to view this page. Please log in again or contact support for assistance.",
    FORBIDDEN: "Access forbidden: You do not have the necessary permissions. Please contact the administrator for assistance.",
    GENERIC_ERROR: "Something went wrong on our end. We’re working to resolve the issue. Please try again later or contact support if the problem continues.",
    NETWORK_ERROR: "Network error. Please check your connection."
};
